import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
  Paper,
  Typography
} from '@mui/material';

const FeatureTable = ({
  features,
  selectedFeatures,
  onFeatureToggle,
  title,
  tierTypes = ['Low', 'Mid', 'High'],
  featureKey = 'id',
  featureNameKey = 'name',
  featureType = 'category'
}) => {
  return (
    <>
      <Typography variant="subtitle1" gutterBottom>
        {title}
      </Typography>
      <TableContainer component={Paper} elevation={0}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Feature</TableCell>
              {tierTypes.map(tierType => (
                <TableCell key={tierType} align="center">{tierType} Tier</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {features.map(feature => (
              <TableRow key={feature[featureKey]}>
                <TableCell>{feature[featureNameKey]}</TableCell>
                {tierTypes.map(tierType => (
                  <TableCell key={tierType} align="center">
                    <Checkbox
                      checked={
                        featureType === 'category' 
                          ? selectedFeatures[tierType]?.categoryFeatures?.some(
                              f => f.globalFeatureId === feature[featureKey] && f.categoryId === feature.categoryId
                            )
                          : selectedFeatures[tierType]?.additionalFeatures?.some(
                              f => f.additionalFeatureId === feature[featureKey] && f.categoryId === feature.categoryId
                            )
                      }
                      onChange={(e) => {
                        onFeatureToggle(
                          tierType,
                          feature.categoryId,
                          feature[featureKey],
                          e.target.checked,
                          featureType
                        );
                      }}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default FeatureTable;
